import * as actionTypes from '../actionTypes/editResumeForm';

export default {
  /**
   * Update the image key
   */
  clearUnusedUrls: (params) => ({
    type: actionTypes.CLEAR_UNUSED_URLS,
    payload: params,
  }),

  updateProfileImage: (params) => ({
    type: actionTypes.UPDATE_PROFILE_IMAGE,
    payload: params,
  }),

  /**
   * Update blobURL on initial load without changing history nodes but the properties
   * Refer ComponentDidMount of
   * ./src/components/userDocuments/editDocument/editResume/EditSpace/EditorPane/RenderContent/PersonalInfo/profileImage.jsx
   * for more details
   */
  updateBlobURL: (params) => ({
    type: actionTypes.UPDATE_BLOB_URL,
    payload: params,
  }),
  clearBlobURL: (params) => ({
    type: actionTypes.CLEAR_BLOB_URL,
    payload: params,
  }),
  updateUnusedUrls: (params) => ({
    type: actionTypes.UPDATE_UNUSED_URLS,
    payload: params,
  }),
  updateSection: (params) => ({
    type: actionTypes.UPDATE_SECTION,
    payload: params,
  }),

  setPages: (params) => ({
    type: actionTypes.SET_PAGES,
    payload: params,
  }),

  updateExport: (params) => ({
    type: actionTypes.UPDATE_EXPORT,
    payload: params,
  }),

  resetHistory: (params) => ({
    type: actionTypes.RESET_HISTORY,
    payload: params,
  }),

  setCounter: (params) => ({
    type: actionTypes.SET_RESUME_COUNTER_VALUE,
    payload: params,
  }),

  setSaveStatus: (params) => ({
    type: actionTypes.SET_SAVE_STATUS,
    payload: params,
  }),

  setResumeType: (params) => ({
    type: actionTypes.SET_RESUME_TYPE,
    payload: params,
  }),

  setCollapse: (params) => ({
    type: actionTypes.SET_RESUME_CARDS_COLLAPSE,
    payload: params,
  }),

  setDrag: (params) => ({
    type: actionTypes.SET_DRAG,
    payload: params,
  }),

  setDragOverCords: (params) => ({
    type: actionTypes.SET_DRAG_OVER_CORDS,
    payload: params,
  }),

  showError: (params) => ({
    type: actionTypes.SHOW_ERROR,
    payload: params,
  }),

  updateRemoveOnNextLoad: (params) => ({
    type: actionTypes.UPDATE_REMOVE_ON_NEXT_LOAD,
    payload: params,
  }),

  updateEventTypes: (params) => ({
    type: actionTypes.UPDATE_EVENT_TYPES,
    payload: params,
  }),

  updateEditedInputs: (params) => (dispatch) => {
    let actionData = {
      payload: {
        ...params,
      },
    };

    actionData = {
      ...actionData,
      type: actionTypes.UPDATE_EDITED_INPUTS,
    };

    dispatch(actionData);
  },

  setFileImportStatus: (params) => (dispatch) => {
    const { fileImported, isFileImporting } = params;

    let actionData = {
      payload: {
        isFileImporting,
      },
      type: actionTypes.SET_FILE_IMPORT_STATUS,
    };

    if (fileImported) {
      actionData = {
        ...actionData,
        payload: {
          ...actionData.payload,
          fileImported: false,
        },
      };
    }

    dispatch(actionData);
  },
  updateEditedInputsLinkedInOptimizer: (params) => (dispatch) => {
    let actionData = {
      payload: {
        ...params,
      },
    };

    actionData = {
      ...actionData,
      type: actionTypes.UPDATE_EDITED_INPUTS_LINKEDIN_OPTIMIZER,
    };

    dispatch(actionData);
  },
  updateEditedInputsQuestionsGenerator: (params) => (dispatch) => {
    let actionData = {
      payload: {
        ...params,
      },
    };

    actionData = {
      ...actionData,
      type: actionTypes.UPDATE_EDITED_INPUTS_QUESTIONS_GENERATOR,
    };

    dispatch(actionData);
  },

  setImportFileData: (params) => (dispatch) => {
    let actionData = {
      payload: {
        ...params,
      },
    };

    actionData = {
      ...actionData,
      type: actionTypes.SET_IMPORT_FILE_DATA,
    };

    dispatch(actionData);
  },
};
